// Custom

// Original
$(document).on('change click blur', '.nospace', function () {
  $(this).val(del_space($(this).val()));
});
$(document).on('change click blur', '.nohyphen', function () {
  $(this).val(del_hyphen($(this).val()));
});
$(document).on('change click blur', '.trim', function () {
  $(this).val(trim($(this).val()));
});
$(document).on('change click blur', '.hankaku', function () {
  $(this).val(hankaku($(this).val()));
});
$(document).on('change click blur', '.zenkaku', function () {
  $(this).val(zenkaku($(this).val()));
});
$(document).on('change click blur', '.hankaku-num-only', function () {
  $(this).val(hankaku_num_only($(this).val()));
});
$(document).on('change click blur', '.zenkaku-num-only', function () {
  $(this).val(zenkaku_num_only($(this).val()));
});
$(document).on('change click blur', '.zenkaku-katakana-only', function () {
  $(this).val(del_num(only_katakana(zenkaku($(this).val()))));
});
$(document).on('change click blur', '.num-and-hyphen', function () {
  $(this).val(numberAndHyphen($(this).val()));
});
$(document).on('change click blur', '.zenkaku-only', function () {
  $(this).val(han2zen(del_hankaku(zenkaku($(this).val()))));
});
$(document).on('change click blur', '.hankaku-only', function () {
  $(this).val(del_zenkaku(hankaku($(this).val())));
});
$(document).on('change click blur', '.hiragana', function () {
  $(this).val(conv_hiragana($(this).val()));
});
$(document).on('change click blur', '.katakana', function () {
  $(this).val(conv_katakana($(this).val()));
});
$(document).on('change click blur', '.hiragana-only', function () {
  $(this).val(only_hiragana($(this).val()));
});
$(document).on('change click blur', '.katakana-only', function () {
  $(this).val(only_katakana($(this).val()));
});
$(document).on('change click blur', '.num-only', function () {
  $(this).val(only_num($(this).val()));
});
$(document).on('change click blur', '.without-num-alphabet', function () {
  $(this).val(del_num(del_alphabet($(this).val())));
});
/**
* ------------------------------------------------------------
* 変換関数
*/

/**
* 生年月日
*/
function isValidDate() {
  const y = $('.js-birth-y').val(),
      m = $('.js-birth-m').val(),
      d = $('.js-birth-d').val();
  if (y === '' || m === '' || d === '') { return true }

  const date = new Date(y + '-' + m + '-' + d);
  // console.log(date)
  // console.log(m);
  // console.log(date.getMonth());
  // month - 1 since the month index is 0-based (0 = January)
  return ((date.getFullYear() == y) && (date.getMonth() == m - 1) && (date.getDate() == d))
}

/**
* できるだけ半角にする
*/
function hankaku(t) {
  return (t + '').replace(/[！-～]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}

/**
* できるだけ全角にする
*/
function zenkaku(t) {
  return (t + '').replace(/[!-~]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
  });
}

/**
* 半角数字だけにする
*/
function hankaku_num_only(t) {
  return (hankaku(t)).replace(/[^0-9]/g, '');
}

/**
* 全角数字だけにする
*/
function zenkaku_num_only(t) {
  return (zenkaku(t)).replace(/[^０-９]/g, '');
}

/**
* 半角に変換後、数字とハイフンだけにする
*/
function numberAndHyphen(t) {
  return (hankaku(t)).replace(/[ー－―～＿]+/g, '-').replace(/[^0-9\-]/g, '');
}

/**
* 半角を削除
*/
function del_hankaku(t) {
  return (t + '').replace(/[!-~\s]/g, '');
}

/**
* 全角を削除
*/
function del_zenkaku(t) {
  return (t + '').replace(/[^!-~\s]/g, '');
}

/**
* 数字を削除
*/
function del_num(t) {
  return (t + '').replace(/[0-9０-９]+/g, '');
}

/**
* アルファベットを削除
*/
function del_alphabet(t) {
  return (t + '').replace(/[a-zA-Zａ-ｚＡ-Ｚ]+/g, '');
}

/**
* 先頭と末尾の空白と改行を削除
*/
function trim(t) {
  return (t + '').replace(/^[\s]*/, '').replace(/[\s]*$/, '');
}

/**
* 空白・改行を削除
*/
function del_space(t) {
  return (t + '').replace(/[\s　]+/g, '');
}

/**
* ハイフンを削除
*/
function del_hyphen(t) {
  return (t + '').replace('-', '');
}

/**
* 平仮名だけにする
*/
function only_hiragana(t) {
  t = conv_hiragana(t);
  return (t + '').replace(/[^ぁ-ん０-９ー\s]+/g, '');
}

/**
* ひらがなに変換する
*/
function conv_hiragana(t) {
  t = zenkaku(t);
  return (t + '').replace(/[ァ-ン]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0x60);
  });
}

/**
* カタカナだけにする
*/
function only_katakana(t) {
  t = conv_katakana(t);
  return (t + '').replace(/[^ァ-ン０-９ー\s]+/g, '');
}

/**
* 数字だけにする
*/
function only_num(t) {
  return (t + '').replace(/[^0-9]/g, '');
}

/**
* カタカナに変換する
*/
function conv_katakana(t) {
  t = zenkaku(t);
  return (t + '').replace(/[ぁ-ん]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) + 0x60);
  });
}

/**
* 半角カナを全角カナに変換。
*
*
*/
function han2zen(t) {
  replaceFm = ['ｳﾞ','ｶﾞ','ｷﾞ','ｸﾞ','ｹﾞ','ｺﾞ'
      ,'ｻﾞ','ｼﾞ','ｽﾞ','ｾﾞ','ｿﾞ'
      ,'ﾀﾞ','ﾁﾞ','ﾂﾞ','ﾃﾞ','ﾄﾞ'
      ,'ﾊﾞ','ﾋﾞ','ﾌﾞ','ﾍﾞ','ﾎﾞ'
      ,'ﾊﾟ','ﾋﾟ','ﾌﾟ','ﾍﾟ','ﾎﾟ'];
  replaceTo = ['ヴ','ガ','ギ','グ','ゲ','ゴ'
      ,'ザ','ジ','ズ','ゼ','ゾ'
      ,'ダ','ヂ','ヅ','デ','ド'
      ,'バ','ビ','ブ','ベ','ボ'
      ,'パ','ピ','プ','ペ','ポ'];
  for (const key in replaceFm) {
      t = t.replace(new RegExp(replaceFm[key], 'g'),replaceTo[key]);
  }

  replaceFm = ['ｱ','ｲ','ｳ','ｴ','ｵ'
      ,'ｶ','ｷ','ｸ','ｹ','ｺ'
      ,'ｻ','ｼ','ｽ','ｾ','ｿ'
      ,'ﾀ','ﾁ','ﾂ','ﾃ','ﾄ'
      ,'ﾅ','ﾆ','ﾇ','ﾈ','ﾉ'
      ,'ﾊ','ﾋ','ﾌ','ﾍ','ﾎ'
      ,'ﾏ','ﾐ','ﾑ','ﾒ','ﾓ'
      ,'ﾔ','ﾕ','ﾖ'
      ,'ﾗ','ﾘ','ﾙ','ﾚ','ﾛ'
      ,'ﾜ','ｦ','ﾝ'
      ,'ｧ','ｨ','ｩ','ｪ','ｫ'
      ,'ｬ','ｭ','ｮ','ｯ'
      ,'､','｡','ｰ','｢','｣','ﾞ','ﾟ'];
  replaceTo = ['ア','イ','ウ','エ','オ'
      ,'カ','キ','ク','ケ','コ'
      ,'サ','シ','ス','セ','ソ'
      ,'タ','チ','ツ','テ','ト'
      ,'ナ','ニ','ヌ','ネ','ノ'
      ,'ハ','ヒ','フ','ヘ','ホ'
      ,'マ','ミ','ム','メ','モ'
      ,'ヤ','ユ','ヨ'
      ,'ラ','リ','ル','レ','ロ'
      ,'ワ','ヲ','ン'
      ,'ァ','ィ','ゥ','ェ','ォ'
      ,'ャ','ュ','ョ','ッ'
      ,'、','。','ー','「','」','”',''];
  for (const key in replaceFm) {
      t = t.replace(new RegExp(replaceFm[key], 'g'),replaceTo[key]);
  }
  return t;
}